import React from 'react';
type Tome = {
  number: string;
  title: string;
  range: string;
  promise: string;
  badge: string;
  flag?: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Day-One Ready',
  range: 'Install the system · 22 Session Cards',
  promise: 'The volume that lets you teach tomorrow: the Four-Block Session and your first classes for absolute beginners.',
  badge: 'bg-court-teal text-white',
  flag: 'Start here',
  contents: ['The Four-Block Session in 30, 60 and 90-minute shapes', 'The Court Setup Map: any court ready in five minutes', 'The Level Ladder and the Rotation Grid (2 to 16+ players)', 'First classes: 60-min, 30-min express, private, rainy-day indoor, 12+ drop-in', 'Your two-minute opening script and a 20-cue beginner bank']
}, {
  number: '02',
  title: 'The Beginner Install',
  range: 'Beginner skills · 25 Session Cards',
  promise: 'The full beginner skill curriculum, in the order it actually sticks — until they can play a real game.',
  badge: 'bg-court-blue text-white',
  contents: ['The Skill Ladder: serve, return, drives, dink, volley — in teaching order', 'The Consistency Count: score the reps so players see progress', 'Getting to the line and the transition zone without panic', 'Beginner doubles: who takes the middle, simple stacking, scoring', 'Quick-start: an 8-week beginner course']
}, {
  number: '03',
  title: 'The Intermediate Install',
  range: '3.0 to 3.5 · 25 Session Cards',
  promise: 'The jump from 3.0 to 3.5: third shot, reset, transition, positioning and shot selection.',
  badge: 'bg-[#1E4E80] text-white',
  contents: ['The Third-Shot Decision: drop or drive, read off the return', 'The Reset Rule: when to take the pace off and start over', 'The Stacking Map: who goes where, in one picture', 'Shot selection: attack the ball that sits up, leave the one that doesn’t', 'Quick-start: a 6-week intermediate block']
}, {
  number: '04',
  title: 'Game & Situation Sessions',
  range: 'Technique to points · 24 Session Cards',
  promise: 'Turn technique into points won — patterns, scored games and match scenarios for every level.',
  badge: 'bg-court-coral text-white',
  contents: ['The Shot-Selection Clock and the Pressure Ladder', 'Point patterns: first four shots, race to the kitchen, reset-reset-attack', 'Scored games: game to 7 with one focus rule, king of the court, 0–5 comeback', 'Scenarios: down 8–10, body attacks, the lobber, wind and sun, serving for the match', 'Doubles communication, poaching and guided match play']
}, {
  number: '05',
  title: 'Clinic Ready',
  range: 'Group clinics · 20 Clinic Cards',
  promise: 'Run group clinics from 4 to 40 players — mixed levels and big groups, with no one standing in line.',
  badge: 'bg-gold text-gold-ink',
  flag: 'Core value',
  contents: ['Clinic blueprints: 45, 60, 90 minutes and half-day', 'Mixed-level clinics with the Level Ladder at every station', 'The Station Wheel and the 2-Court Clinic Map', '16 players on one court, 24 on two, 32+ with assistants', 'Themed, partner, drop-in, corporate and youth summer clinics']
}, {
  number: '06',
  title: 'Season Ready',
  range: 'Full-season programs · 20 Program Cards',
  promise: 'Programs that repeat all season: courses, leagues, round-robins, social nights, retention and player progress.',
  badge: 'bg-[#0E7490] text-white',
  contents: ['The Season Arc: 8-week course, 12-week program, weekly clinic, weekend camp', 'The Ladder & Round-Robin Engine + grids for 8, 12 and 16 players', 'Drop-in and social nights that don’t turn into chaos', 'The Retention Loop: a first class built so they book the second', 'Player progress card and the season-closing session']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-navy" data-id="element-251" data-mp="3c85c4jrgw3ee">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-252" data-mp="37a3u825s2a4i">
        <div className="text-center" data-id="element-253" data-mp="3lxf6y7dp4067">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-254" data-mp="3lygs54ofe31n">
            The complete system
          </p>
          <h2 id="tomes-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-255" data-mp="3h54692b4sacl">
            Inside Court Ready — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-256" data-mp="8r5aa0o5soz3">
            From your very first class to a full season — lessons, clinics and
            programs in the order you&apos;ll actually need them. 136 Session
            Cards, each one ready to print and run.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-257" data-mp="25joy6nbmsnq8">
          {tomes.map(tome => <article key={tome.number} className={`flex flex-col rounded-2xl border bg-navy-card p-6 shadow-card ${tome.flag ? 'border-gold ring-1 ring-gold' : 'border-navy-line'}`} data-id="element-258" data-mp="l0uz1jk1qjd5">
              <div className="flex items-center gap-2.5" data-id="element-259" data-mp="b9h4lq6yc9qv">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg font-display text-lg ${tome.badge}`} data-id="element-260" data-mp="g9mnohz5onxc">
                  {tome.number}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-261" data-mp="6d9v5nfckg46">
                  Volume {tome.number}
                </span>
                {tome.flag && <span className="ml-auto rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-262" data-mp="3thzijw000yk9">
                    {tome.flag}
                  </span>}
              </div>
              <h3 className="mt-3 text-lg font-bold leading-snug text-ink" data-id="element-263" data-mp="1rp1uedh62u5n">
                {tome.title}
              </h3>
              <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-gold-deep" data-id="element-264" data-mp="1l9kvrw1bf8rk">
                {tome.range}
              </p>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-265" data-mp="1gbjhdoeu3xmf">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-navy-line pt-4" data-id="element-266" data-mp="1bbx0n4zsrz8v">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-267" data-mp="28xue2nzbledy">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-268" data-mp="23zsu80u2lb1f" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}